// extracted by mini-css-extract-plugin
export default {"main":"ModalEditarTemario_main__5BSxn","intro":"ModalEditarTemario_intro__ZitX-","input":"ModalEditarTemario_input__rnx2L"};